import gql from "graphql-tag"

const fragment = gql`
  fragment externalTenantMetadata on TenantMetadata {
    uuid
    config {
      alternativeAppDownloadImage
    }
    homepage {
      isEnabled
      widgets {
        id
        type
        image {
          image
          link
          openLinkInNewTab
        }
        imageWithText {
          image
          header
          body
          link
          openLinkInNewTab
        }
        video {
          videoUrl
        }
        layouts {
          desktop {
            height
            width
            xOffset
            yOffset
          }
          mobile {
            height
            width
            xOffset
            yOffset
          }
        }
      }
    }
  }
`

export const toString = fragment.loc.source.body

export default fragment
